"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRouteSource = void 0;
var getRouteSource = function (_a) {
    var points = _a.points;
    var routeId;
    var routes = points;
    return {
        layers: [
            {
                data: {
                    id: "lines",
                    type: "line",
                    source: "routes",
                    layout: {
                        "line-join": "round",
                        "line-cap": "round",
                    },
                    paint: {
                        "line-color": ["get", "line-color"],
                        "line-width": [
                            "case",
                            ["boolean", ["feature-state", "hover"], false],
                            6,
                            3,
                        ],
                    },
                },
                onMouseEnter: function (e, map) {
                    // @ts-ignore
                    if (e.features.length > 1) {
                        if (routeId) {
                            map.removeFeatureState({
                                source: "containers",
                                // @ts-ignore
                                id: routeId,
                            });
                        }
                        // @ts-ignore
                        routeId = e.features[0].id;
                        map.setFeatureState({
                            source: "routes",
                            // @ts-ignore
                            id: routeId,
                        }, {
                            hover: true,
                        });
                    }
                    // @ts-ignore
                    map.setFilter("lines", [
                        "==",
                        ["get", "id"],
                        // @ts-ignore
                        e.features[0].properties.id,
                    ]);
                    map.getCanvas().style.cursor = "pointer";
                },
                onMouseLeave: function (e, map) {
                    if (routeId || routeId === 0) {
                        map.setFeatureState({
                            source: "routes",
                            // @ts-ignore
                            id: routeId,
                        }, {
                            hover: false,
                        });
                    }
                    routeId = null;
                    map.setFilter("lines", null);
                    map.getCanvas().style.cursor = "";
                },
            },
        ],
        sourceId: "routes",
        source: {
            type: "geojson",
            generateId: true,
            data: {
                type: "FeatureCollection",
                features: routes.map(function (route) {
                    return {
                        type: "Feature",
                        properties: {
                            id: route.id,
                            "line-color": "" + route.color,
                        },
                        geometry: {
                            coordinates: route.locations.map(function (location) { return [
                                location.latitude,
                                location.longitude,
                            ]; }),
                            type: "LineString",
                        },
                    };
                }),
            },
        },
        images: []
    };
};
exports.getRouteSource = getRouteSource;
